var map = {
	".": "V3+W",
	"./": "V3+W",
	"./01_balance": "bzx+",
	"./01_balance.json": "bzx+",
	"./02_order": "K1eD",
	"./02_order.json": "K1eD",
	"./03_setting": "2Cei",
	"./03_setting.json": "2Cei",
	"./index": "V3+W",
	"./index.js": "V3+W"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2p/L";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/cswap/websocket/account ^.*$
// module id = 2p/L
// module chunks = 3